<template>
  <div class="loading" v-show="visible">
    <el-icon v-if="!hideIcon" :size="24" name="loading1"><Loading /></el-icon>
    <p>{{ title || '加载中...' }}</p>
  </div>
</template>

<script lang="ts" setup>
import { Loading } from '@element-plus/icons-vue';

defineProps<{
  visible: boolean;
  title?: string;
  hideIcon?: boolean;
}>();


</script>

<style lang="scss">
.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3000;
  p {
    margin-top: 16px;
    color: #fff !important;
  }
}
</style>
